"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pharmacy = void 0;
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = __importStar(require("react-native-svg"));
function Pharmacy({ size = 20, color = '#3db384' }) {
    return (react_1.default.createElement(react_native_svg_1.default, { width: size, height: size, viewBox: "0 0 79 77" },
        react_1.default.createElement(react_native_svg_1.G, { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
            react_1.default.createElement(react_native_svg_1.G, { fill: color, fillRule: "nonzero" },
                react_1.default.createElement(react_native_svg_1.Path, { d: "M40.356.47l.128.117 37.931 38a2 2 0 01-2.703 2.943l-.127-.117-6.085-6.096V75a2 2 0 01-1.85 1.995L67.5 77h-56a2 2 0 01-1.995-1.85L9.5 75V35.175l-6.068 6.222a2 2 0 01-2.7.15l-.129-.115a2 2 0 01-.15-2.7l.115-.129 37.07-38A2 2 0 0140.355.47zm-1.271 4.377L13.5 31.074V73h52V31.31L39.085 4.847z" }),
                react_1.default.createElement(react_native_svg_1.Path, { d: "M39 27a3 3 0 012.995 2.824L42 30l-.001 11.5H53.5a3 3 0 01.176 5.995l-.176.005H41.999L42 59a3 3 0 01-5.995.176L36 59l-.001-11.5H24.5a3 3 0 01-.176-5.995l.176-.005h11.499L36 30a3 3 0 013-3z" })))));
}
exports.Pharmacy = Pharmacy;
